var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18.8,
    y: 12.89,
    width: 2.4,
    height: 2.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20,8.2C13.483,8.2,8.2,13.483,8.2,20S13.483,31.8,20,31.8S31.8,26.517,31.8,20     C31.789,13.488,26.512,8.211,20,8.2z M20,29.7c-5.357,0-9.7-4.343-9.7-9.7s4.343-9.7,9.7-9.7s9.7,4.343,9.7,9.7v0     C29.694,25.355,25.355,29.694,20,29.7z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18.8,
    y: 17.39,
    width: 2.4,
    height: 9.221
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/Info.5fde6209.svg";
export { ForwardRef as ReactComponent };